// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__AwwUT","content":"LoadingAlert_content__FrwjD"};